import List from './List'
import Login from './Login'
import Email from './Email'
import NotFound from './NotFound'


export default {
    List,
    Login,
    Email,
    NotFound
}
